import connectionProxy from './connectionProxy'

export const getNews= (
  areaId,
) => 
  connectionProxy.http.get(
    `/novidades?area_id=${areaId}`
  )


// WEBPACK FOOTER //
// ./src/api/news.js